import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { scrollToPricing } from './utils';
const faqs = [{
  q: '¿Qué recibo al comprar SIC 360?',
  a: 'Recibís el sistema completo de 6 Tomos de Sistemas de Información Contable con actividades progresivas, proyectos y resolucionario docente, más los 4 bonos exclusivos: Banco de Ejemplos Reales Argentinos, Clases Salvavidas, Evaluaciones Listas con Rúbricas Extra y el Mapa Anual de Contenidos. Todo en formato digital para descargar inmediatamente.'
}, {
  q: '¿Cuándo me llega?',
  a: 'El acceso es inmediato. Una vez confirmado el pago, recibís un email con las instrucciones para descargar todo el material. Podés empezar a usarlo en menos de 5 minutos.'
}, {
  q: '¿Es físico o digital?',
  a: 'Es 100% digital. No hay envíos físicos. Esto te permite acceder al instante y llevarlo siempre con vos en cualquier dispositivo. Además, podés imprimirlo si preferís trabajar en papel.'
}, {
  q: '¿Necesito ser docente recibido?',
  a: 'No necesitás título universitario en contabilidad. SIC 360 está diseñado para cualquier docente de nivel secundario que dicte Sistemas de Información Contable, Administración o materias afines. Si das SIC, esto es para vos.'
}, {
  q: '¿Tengo acceso para siempre?',
  a: 'Sí, el acceso es vitalicio. Una vez que descargás el material, es tuyo para siempre. No hay vencimientos, renovaciones ni pagos mensuales. Comprás una vez y lo usás todos los años que quieras.'
}, {
  q: '¿Qué pasa si no me llega el acceso?',
  a: 'Si no recibís el email en los próximos 10 minutos, revisá tu carpeta de spam. Si aún así no lo encontrás, escribinos a soporte y te lo reenviamos de inmediato. Siempre respondemos en menos de 24 horas.'
}, {
  q: '¿Es una compra segura?',
  a: 'Totalmente segura. Usamos la plataforma de pago más confiable de Argentina, con encriptación SSL. Aceptamos todas las tarjetas y Mercado Pago. Además, tenés garantía de devolución de 7 días sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 bg-white" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-8 md:mb-14" data-id="element-32">
          <h2 className="text-xs font-bold tracking-widest text-[#1a365d] uppercase mb-2" data-id="element-33">
            PREGUNTAS FRECUENTES
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold text-slate-900 flex items-center justify-center gap-2" data-id="element-34">
            <HelpCircle className="text-[#1a365d] shrink-0" size={28} data-id="element-35" />
            Resolvemos tus dudas
          </h3>
        </div>

        <div className="space-y-2.5 md:space-y-4 mb-10 md:mb-14" data-id="element-36">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50 hover:bg-slate-100 transition-colors" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-3.5 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-38">
                <span className="font-bold text-slate-900 pr-6 text-sm md:text-base" data-id="element-39">
                  {faq.q}
                </span>
                <ChevronDown className={`text-slate-500 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={18} data-id="element-40" />
              </button>
              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-4 md:px-6 pb-4 text-slate-600 text-sm leading-relaxed border-t border-slate-200 pt-3" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center" data-id="element-44">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-[#d4a017] hover:bg-[#b88a14] text-slate-900 font-bold text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-2" data-id="element-45">
            👉 Quiero acceder ahora sin riesgo
          </button>
        </div>
      </div>
    </section>;
}